import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { useLocale } from 'next-intl';
import type { MouseEvent } from 'react';

import { EventType } from '@/analytics/types';
import ArticleCardsDesktop from '@/app/[locale]/science-and-research/_components/ArticleCardsDesktop';
import ArticleCardsMobile from '@/app/[locale]/science-and-research/_components/ArticleCardsMobile';
import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

import { getPerimenopauseArticleCards } from '../_data/perimenopauseArticlesData';

const PerimenopauseArticles = () => {
  const locale = useLocale();
  const articleCards = getPerimenopauseArticleCards(
    getLocalePartialUrl(locale),
  );

  const handleClick = async (
    event: MouseEvent<HTMLAnchorElement>,
  ): Promise<void> => {
    event.preventDefault();
    const target = event.currentTarget;
    const path = target.getAttribute('href');
    await window.ouraAnalytics.track(EventType.ModuleClicked, {
      action: 'user moves out of eComm to blog',
      cta: 'click to launch',
      location: 'footer',
      path,
    });
    window.open(path!, '_blank');
  };

  return (
    <section className="pt-20 lg:pt-32" data-cy="perimenopause-articles">
      <LandingPageBlurb
        description={{
          alignment: 'top',
          className: 'text-xl max-lg:text-center',
          colStart: { lg: 15 },
          key: 'perimenopause_learn_more_copy',
        }}
        title={{
          colEnd: { lg: 13, xxl: 11 },
          key: 'perimenopause_learn_more_title',
          className: 'max-lg:text-center',
          multiline: true,
          font: 'serif',
        }}
      />
      <LayoutGrid className="pt-14 lg:pt-20">
        <GridItem colStart={{ sm: 'main' }} colEnd={{ sm: 'full', lg: 'main' }}>
          <ArticleCardsMobile
            articleCards={articleCards}
            onClick={handleClick}
          />
          <ArticleCardsDesktop
            articleCards={articleCards}
            onClick={handleClick}
          />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default PerimenopauseArticles;
